export default "__VITE_ASSET__CJ7YtR0u__"